import React from "react";
import "./Tooltip.scss";

const Tooltip: React.FC = (props) => <p className="tooltip">{props.children}</p>;

export default Tooltip;
